/**
 * @author madhu.sudhan
 * @Date: 2023-10-12 15:07:51
 * @Last Modified by: ankit
 * @Last Modified time: 2024-04-18 13:32:19
 */

import { createStructuredSelector } from 'reselect';
import { bool, func, shape } from 'prop-types';
import { resetPopup } from '../HeaderContainer/actions';
import { SetChannelFlagYbl, fetchCardData, fetchOnlineTransactionLimit, updateOnlineTransactionLimit, yblModifyLimitsOtp } from './actions';
import { select_card_data_ybl } from '../NetworkCards/selectors';
import { isTransactionLimitsLoading, isYblModifyLimitOtpLoading, selectYesBankTransaction, updateYesBankTransaction, yblModifyLimitsOtpSuccess, yblSetChannelFlagSuccess } from './selectors';
import { selectHeaderContainerJS } from '../HeaderContainer/selectors';
import { UPDATE_ONLINE_TRANSACTION_LIMIT, YBL_MODIFY_LIMITS_CONSTANTS } from './constants';
import { FETCH_CARD_DATA_YBL } from '../NetworkCards/constants';


const YesBankTransactionLimitsProps = {
  isYblTransactionLimitsLoading: bool.isRequired,
  yblModifyLimitOtpLoading: bool.isRequired,
  cardData: shape({}).isRequired,
  location: shape({}).isRequired,
  transactionLimits: shape({}).isRequired,
  updateTransactionLimits: shape({}).isRequired,
  SelectUserDetails: shape({}).isRequired,
  isYblModifyLimitsOtpSuccess: shape({}).isRequired,
  isyblSetChannelFlagSuccess: shape({}).isRequired,
  history: shape({}).isRequired,
  onFetchCardData: func.isRequired,
  onFetchOnlineTransactionLimit: func.isRequired,
  onUpdateOnlineTransactionLimit: func.isRequired,
  onResetPopup: func.isRequired,
  onYblModifyLimitsOtp: func.isRequired,
  onSetUpdateYesBankTransactionLimitSuccess: func.isRequired,
  onSetYesBankTransactionLimitOtpSuccess: func.isRequired,
  onSetChannelFlagYbl: func.isRequired,
  onSetFetchCardData: func.isRequired,
};


const yesBankTransactionLimitsMapDispatchToProps = (dispatch) => ({
  onFetchCardData: () => dispatch(fetchCardData()),
  onFetchOnlineTransactionLimit: () => dispatch(fetchOnlineTransactionLimit()),
  onUpdateOnlineTransactionLimit: (payload) => dispatch(updateOnlineTransactionLimit(payload)),
  onResetPopup: (payload, actionType, alertType) => dispatch(resetPopup(payload, actionType, alertType)),
  onYblModifyLimitsOtp: (payload) => dispatch(yblModifyLimitsOtp(payload)),
  onSetUpdateYesBankTransactionLimitSuccess: () => dispatch({ type: YBL_MODIFY_LIMITS_CONSTANTS.YBL_UPDATE_LIMITS_OTP_SUCCESS, payload: { status: false } }),
  onSetYesBankTransactionLimitOtpSuccess: () => dispatch({ type: UPDATE_ONLINE_TRANSACTION_LIMIT, payload: { status: false } }),
  onSetChannelFlagYbl: (payload) => dispatch(SetChannelFlagYbl(payload)),
  onSetFetchCardData: () => dispatch({ type: FETCH_CARD_DATA_YBL, payload: { status: false } }),
});

const yesBankTransactionLimitsMapStateToProps = createStructuredSelector({
  cardData: select_card_data_ybl(),
  transactionLimits: selectYesBankTransaction(),
  updateTransactionLimits: updateYesBankTransaction(),
  SelectUserDetails: selectHeaderContainerJS('userDetails'),
  isYblTransactionLimitsLoading: isTransactionLimitsLoading(),
  isYblModifyLimitsOtpSuccess: yblModifyLimitsOtpSuccess(),
  yblModifyLimitOtpLoading: isYblModifyLimitOtpLoading(),
  isyblSetChannelFlagSuccess: yblSetChannelFlagSuccess(),
});

export { YesBankTransactionLimitsProps, yesBankTransactionLimitsMapStateToProps, yesBankTransactionLimitsMapDispatchToProps };



// WEBPACK FOOTER //
// client/containers/YesBankTransactionLimits/yesBankTransactionLimitsDataHandler.js